import 'slick-carousel/slick/slick'

export default class KnowledgeBankSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-knowledge-bank-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                infinite: true,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                prevArrow: $('.js-kb-slider-previous'),
                nextArrow: $('.js-kb-slider-next'),
                appendDots: $('.js-kb-slider-dots'),

                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });
        }

    }

};

new KnowledgeBankSlider();